export function mapNotionImageUrl(url?: string): string {
  if (!url) return "#";
  try {
    const u = new URL(url);
    const base = "/api/blog/image";
    const q = new URLSearchParams();
    q.set("src", u.toString());
    return base + "?" + q.toString();
  } catch {
    return url;
  }
}
